import { render } from "./TestImageCSS.vue?vue&type=template&id=667ae439&scoped=true"
import script from "./TestImageCSS.vue?vue&type=script&lang=js"
export * from "./TestImageCSS.vue?vue&type=script&lang=js"

import "./TestImageCSS.vue?vue&type=style&index=0&id=667ae439&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667ae439"]])

export default __exports__